var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurvedArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 55,
    viewBox: "0 0 110 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2C2 2 27.3678 3.98103 38.6238 14.6645C49.3499 24.8449 49.3322 47.9132 31.3046 52.4226C25.6486 53.8374 18.844 52.6627 14.3196 48.7825C8.89355 44.129 14.6976 37.7002 19.5723 36.0744C38.426 29.7863 49.3642 48.5776 68.1462 46.3114C88.6266 43.8404 93.467 35.7306 107.382 27.4803M99.4204 26.5246C100.343 26.9759 103.295 27.7989 107.723 27.4803M108 27.4803C106.155 29.3912 102.686 33.8819 103.572 36.5573",
    stroke: "#489D78",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurvedArrow);
export default __webpack_public_path__ + "static/media/curved-arrow.954108948fdc3acf6ae6d269581fc1cf.svg";
export { ForwardRef as ReactComponent };